import {z} from 'zod';

export const webhookIntegrationItemSchema = z.object({
    id: z.number(),
    name: z.string(),
    webhookId: z.string(),
    canBeDeleted: z.boolean(),
    webhookServiceCode: z.string().nullable(),
});

export type WebhookIntegrationItemType = z.infer<typeof webhookIntegrationItemSchema>;

export type CreateWebhookIntegrationType = Pick<
    WebhookIntegrationItemType,
    'name' | 'webhookId' | 'webhookServiceCode'
>;
export type UpdateWebhookIntegrationType = Pick<WebhookIntegrationItemType, 'id' | 'name'>;

export const webhookIntegrationTypeItemSchema = z.object({
    id: z.number(),
    name: z.string(),
    code: z.string(),
});

export type WebhookIntegrationTypeItemType = z.infer<typeof webhookIntegrationTypeItemSchema>;
